import { Arrival } from '../models/dto/arrival/arrival';
import { ReleaseChildren } from '../models/dto/arrival/gates-monitoring/release-children.dto';
import { SimpleUserDto } from '../models/dto/simple-user.dto';
import { ArrivalStatus } from '../models/enum/arrival/arrival-status.enum';
import { HistoryArrival } from '../models/interfaces/arrival/history';
import { currentMessage } from '../utils/arrival/monitoring-message.utils';

export const buildArrivalUpdate = (
  response: Arrival,
  status: ArrivalStatus,
  dtArrived: Date
): Arrival => {
  return {
    id: response.id,
    idAuthorized: response.idAuthorized,
    arrivalForecast: response.arrivalForecast,
    vehicle: response.vehicle,
    employee: response.employee,
    idsChildren: response.idsChildren,
    status: status,
    unpredictable: response.unpredictable,
    history: response.history,
    idGate: response.idGate,
    dtCreated: response.dtCreated,
    dtArrived: new Date(),
  };
};

const buildReleasedHistory = (status: ArrivalStatus): HistoryArrival => {
  return {
    status: status,
    message: currentMessage(status),
  } as HistoryArrival;
};

export const buildReleaseChild = (user: SimpleUserDto): ReleaseChildren => {
  return {
    employee: {
      id: user.id,
      name: `${user.firstName} ${user.lastName}`,
    },
    history: buildReleasedHistory(ArrivalStatus.RELEASED),
  } as ReleaseChildren;
};
